export const keys = {
    all: ["search-results"],
    list: (
        groupID: number,
        searchText: string
    ) => [
            ...keys.all,
            "list",
            {
                groupID,
                searchText
            }
        ],
};
